export default function (options) {
    let target = $(options.target);
    let tssSmall = $('#tss-small');
    let tssMid = $('#tss-mid');
    let tssLarge = $('#tss-large');

    tssSmall.on('click', (e) => {
        e.preventDefault();
        setActiveTssControl(tssSmall);

        target.css({
            fontSize: '16px',
            lineHeight: '26px',
        });
    });

    tssMid.on('click', (e) => {
        e.preventDefault();
        setActiveTssControl(tssMid);

        target.css({
            fontSize: '18px',
            lineHeight: '28px',
        });
    });

    tssLarge.on('click', (e) => {
        e.preventDefault();
        setActiveTssControl(tssLarge);

        target.css({
            fontSize: '20px',
            lineHeight: '30px',
        });
    });

    function setActiveTssControl(parent) {
        $('.control__item svg').removeClass('selectedTextSize');
        $('.svg-indicator-icon').attr('fill', '#999999');
        parent.find('svg .svg-indicator-icon').attr('fill', '#0098FF');
        parent.find('svg').addClass('selectedTextSize');
        let getDivs = document.getElementsByClassName('control_pressed');
        for (let i = 0; i < getDivs.length; i++) {
            if (getDivs[i].getAttribute('aria-pressed') === 'true') {
                getDivs[i].setAttribute('aria-pressed', 'false');
            }
        }
        parent.attr('aria-pressed', 'true');
    }
}
